
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/university/features",
      function () {
        return require("private-next-pages/university/features.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/university/features"])
      });
    }
  